import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CompanyProfileSrvices from "../../../service/setup/company-profile/companyProfileServices";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import moment from "moment/moment";

const useCompanyProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const [operationalTime, setOperationalTime] = useState([]);
  const [operationalDate, setOperationalDate] = useState([]);
  const [updatedOperationalDate, setUpdatedOperationalDate] = useState([]);
  const [tab1, setTab1] = useState(true);
  const [tab2, setTab2] = useState(false);
  const [tab3, setTab3] = useState(false);
  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [managementHistoryList, setManagementHistoryList] = useState([]);
  const [operationalDateData, setOperationalDateData] = useState([]);
  const [isViewDetailPhoto, setIsViewDetailPhoto] = useState(false);

  const { token, grolog_account_id } = useSelector((state) => state.auth);

  const onChangeTab = (tab) => {
    switch (tab) {
      case 1:
        setTab1(true);
        setTab2(false);
        setTab3(false);
        break;
      case 2:
        setTab1(false);
        setTab2(true);
        setTab3(false);
        break;
      case 3:
        setTab1(false);
        setTab2(false);
        setTab3(true);
        break;

      default:
        break;
    }
  };

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  };

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return moment(timestamp).utc().format("HH:mm");
  };

  const doGetManagementHistoryList = async (id) => {
    try {
      const response = await CompanyProfileSrvices.getManagementHistoryList(
        token,
        null,
        dispatch,
        id
      );
      if (response && response.ok) {
        const data = response.data;
        const reorderedData = [];

        for (let i = data.length - 1; i >= 0; i--) {
          const element = data[i];
          reorderedData.push(element);
        }

        setManagementHistoryList(reorderedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDetailCompany = async () => {
    const { success, data } = await CompanyProfileSrvices.detail(
      token,
      grolog_account_id
    );

    if (success) {
      setData(data);
      setOperationalTime(data?.operational_time);
    }
  };

  const getOperationalDates = async () => {
    const { ok, data } = await CompanyProfileSrvices.getOperationalDates(token);
    if (ok) {
      setOperationalDate(data);
    }
  };

  useEffect(() => {
    getDetailCompany();
    getOperationalDates();
    // eslint-disable-next-line
  }, []);

  const _onBackDetail = () => {
    navigate(ROUTES.COMPANY_PROFILE.DETAIL);
  };

  const formatTime = (time) => {
    const formattedTime = moment(time, "HH:mm:ss")
      .format("h:mm a")
      .toUpperCase();

    return formattedTime;
  };

  const _toEdit = () => {
    navigate(ROUTES.COMPANY_PROFILE.EDIT, { state: data?.company_profile_id })
  }

  const viewDetail = () => {
    setIsViewDetailPhoto(true);
  }

  return {
    data,
    tab1,
    tab2,
    tab3,
    onChangeTab,
    operationalTime,
    _onBackDetail,
    formatTime,
    setUserManagementOpen,
    viewDetail,
    isViewDetailPhoto,
    setIsViewDetailPhoto,
    userManagementOpen,
    convertTimestamp,
    convertToTime,
    doGetManagementHistoryList,
    managementHistoryList,
    operationalDate,
    getOperationalDates,
    setOperationalDateData,
    operationalDateData,
    updatedOperationalDate,
    setUpdatedOperationalDate,
    _toEdit
  };
};

export default useCompanyProfile;
